export default __webpack_public_path__ + "static/img-small1-276849bc50f15775b9d6d08d0d865195.jpg";